<template>
  <v-list-item @click="open">
    <v-list-item-avatar>
      <v-icon small color="secondary">fal fa-plus</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="secondary--text">ビザ取得歴を追加する</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="text-xs-right">
      <v-btn text :disabled="true"></v-btn>
    </v-list-item-action>
    <v-dialog v-model="config.status.active" max-width="600" scrollable>
      <v-card>
        <v-card-title class="primary amber blue-grey--text text--darken-4">
          <span class="headline">過去に取得したビザを追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12 class="px-3">
                  <v-select
                    v-model="form.country"
                    label="発行国"
                    item-text="label"
                    item-value="code"
                    :rules="rules.country"
                    :items="getNationItems"
                  />
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-select
                    v-model="form.type"
                    label="ビザの種類"
                    item-text="text"
                    item-value="value"
                    :rules="rules.country"
                    :items="getTypeItems"
                  />
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-menu lazy offset-y full-width
                    v-model="config.datepicker.publish"
                    transition="scale-transition"
                    min-width="290px"
                    :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-text-field readonly required
                        v-model="printFormatedPublish"
                        v-on="on"
                        :rules="rules.publish"
                        label="発行日"
                      />
                    </template>
                    <v-date-picker
                      v-model="form.publish"
                      color="amber"
                      locale="ja"
                      :day-format="date => new Date(date).getUTCDate()"
                      @input="config.datepicker.publish = false"
                    />
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text
            color="secondary"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="secondary"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        },
        datepicker: {
          publish: false
        }
      },
      rules: {
        country: [
          v => !!v || '必須項目です'
        ],
        type: [
          v => !!v || '必須項目です'
        ],
        publish: [
          v => !!v || '必須項目です'
        ]
      },
      form: {
        valid: true,
        status: 'DONE',
        country: '',
        type: '',
        publish: ''
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        status: 'DONE',
        country: '',
        type: '',
        publish: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}about/insert/meta`, {
            cid: this.$route.params.id,
            mtype: 'about.visa',
            form: {
              status: this.form.status,
              country: this.form.country,
              type: this.form.type,
              publish: this.form.publish
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insert',
                data: {
                  type: 'visas',
                  resolve: res.data.data
                }
              })
            }
            this.$set(this.config.status, 'loading', false)
            this.$set(this.config.status, 'active', false)
          })
        })
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    printFormatedPublish () {
      return (
        this.form &&
        this.form.publish
      ) ? this.$moment(this.form.publish).format('YYYY/MM/DD') : ''
    },
    getStatusItems () {
      return this.$mango.about.visa.status
    },
    getNationItems () {
      return Object.keys(this.$mango.nations).filter(key => { return key !== 'JP' }).map(key => {
        return {
          code: key,
          label: this.$mango.nations[key]
        }
      })
    },
    getTypeItems () {
      return Object.keys(this.$mango.about.visa.types).map(key => {
        return {
          value: key,
          text: this.$mango.about.visa.types[key]
        }
      })
    }
  }
}
</script>
